// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2POD_","detailsBorder":"styles_detailsBorder__1eSdQ"};